export const isJestRunning = (): boolean => window.process?.env?.JEST_WORKER_ID !== undefined;

export const isBrowser = (): boolean => {
  return window !== undefined && !window.__IS_SERVER__;
};

export * from './user-agent';
